import axios from "axios";

const api = axios.create({
  baseURL: "https://api.sae-grad.com/api",
});



export default api;
